export const specialList = [
  {
    id: 's1',
    title: '秋季档观影全攻略',
    subtitle: '一份写给影迷的档期生存手册',
    summary:
      '从科幻大片到治愈爱情，从历史史诗到烧脑悬疑，我们把本季最值得走进影院的作品整理成一份清单，帮你在有限的时间里挑到最对的那一部。',
    cover: 'https://readdy.ai/api/search-image?query=stack%20of%20glowing%20cinema%20film%20reels%20and%20tickets%20in%20dramatic%20light%2C%20special%20topic%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=1200&height=675&seq=yz-s1-cover&orientation=landscape',
    articles: [
      {
        id: 's1a1',
        title: '科幻迷必看：《星际回响》的时间悖论解析',
        summary: '从"回响"信号的设定出发，梳理影片中三条交织的时间线，以及那个备受争议的开放式结局。',
        cover: 'https://readdy.ai/api/search-image?query=glowing%20time%20portal%20tunnel%20of%20light%20in%20space%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s1-a1&orientation=landscape',
        source: '御宅屋 · 深度解读',
      },
      {
        id: 's1a2',
        title: '悬疑片怎么挑？三步判断一部推理电影值不值得看',
        summary: '不是所有打着"悬疑"旗号的电影都值得你花两小时。这份挑选指南，帮你避开那些只靠音效吓人的作品。',
        cover: 'https://readdy.ai/api/search-image?query=foggy%20alley%20with%20a%20magnifying%20glass%20and%20old%20case%20files%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s1-a2&orientation=landscape',
        source: '御宅屋 · 观影指南',
      },
      {
        id: 's1a3',
        title: '治愈系片单：适合一个人安静看完的五部电影',
        summary: '当生活有点累的时候，不妨让这些温柔的故事陪你度过一个下午。',
        cover: 'https://readdy.ai/api/search-image?query=cozy%20window%20seat%20with%20a%20warm%20cup%20and%20soft%20afternoon%20light%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s1-a3&orientation=landscape',
        source: '御宅屋 · 影单推荐',
      },
    ],
  },
  {
    id: 's2',
    title: '华语悬疑剧十年精选',
    subtitle: '那些让我们熬夜追完的国产悬疑',
    summary:
      '十年间，华语悬疑剧完成了一次漂亮的蜕变。这个专题带你回顾那些在叙事、影像与人性刻画上留下印记的作品，以及它们背后的创作逻辑。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20moody%20city%20alley%20with%20neon%20reflections%20and%20rain%2C%20special%20topic%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=1200&height=675&seq=yz-s2-cover&orientation=landscape',
    articles: [
      {
        id: 's2a1',
        title: '从案件到人心：国产悬疑剧的叙事升级',
        summary: '好的悬疑剧从来不满足于"谁是凶手"，它更在意案件背后那些说不出口的人性困境。',
        cover: 'https://readdy.ai/api/search-image?query=detective%20board%20with%20photos%20and%20red%20strings%20in%20a%20dark%20room%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s2-a1&orientation=landscape',
        source: '御宅屋 · 剧集观察',
      },
      {
        id: 's2a2',
        title: '《暗夜追凶》为什么能把老题材拍出新意',
        summary: '警匪、失踪、旧案重启……这些元素早已不新鲜，但影片用手持镜头与灰度光影，拍出了久违的窒息感。',
        cover: 'https://readdy.ai/api/search-image?query=rainy%20neon%20city%20street%20with%20a%20lone%20silhouette%20at%20night%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s2-a2&orientation=landscape',
        source: '御宅屋 · 影评',
      },
      {
        id: 's2a3',
        title: '悬疑剧里的"慢"：为什么克制反而更吓人',
        summary: '最高级的紧张感，往往来自长时间的安静。我们聊聊悬疑剧在节奏控制上的那些小心机。',
        cover: 'https://readdy.ai/api/search-image?query=empty%20dim%20corridor%20with%20a%20single%20flickering%20lamp%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s2-a3&orientation=landscape',
        source: '御宅屋 · 剧集观察',
      },
      {
        id: 's2a4',
        title: '跟着悬疑剧学构图：那些值得截图的镜头',
        summary: '一个好的构图，本身就是一句台词。这个专题带你看看悬疑剧里的视觉语言。',
        cover: 'https://readdy.ai/api/search-image?query=cinematic%20symmetrical%20corridor%20shot%20with%20dramatic%20shadows%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s2-a4&orientation=landscape',
        source: '御宅屋 · 影像美学',
      },
    ],
  },
  {
    id: 's3',
    title: '科幻电影视觉美学专题',
    subtitle: '当想象力有了具体的形状',
    summary:
      '从深海到深空，科幻电影用镜头为我们构建了一个个从未踏足的宇宙。这个专题聚焦科幻作品的视觉语言，看看创作者如何把抽象的想象变成可以看见的世界。',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20sci-fi%20nebula%20with%20geometric%20planets%20and%20light%20rings%2C%20special%20topic%20header%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=1200&height=675&seq=yz-s3-cover&orientation=landscape',
    articles: [
      {
        id: 's3a1',
        title: '蓝色与橙色的战争：科幻电影的色彩密码',
        summary: '为什么那么多科幻大片偏爱深蓝与暖橙的对比？这背后其实有一套完整的色彩心理学。',
        cover: 'https://readdy.ai/api/search-image?query=color%20grading%20comparison%20of%20deep%20blue%20and%20warm%20orange%20light%20in%20space%2C%20article%20cover%20visual%2C%20no%20text&width=800&height=500&seq=yz-s3-a1&orientation=landscape',
        source: '御宅屋 · 影像美学',
      },
      {
        id: 's3a2',
        title: '《深海迷航》的声音设计：听不见的地方最可怕',
        summary: '一部好的惊悚片，一半的恐惧是"听"出来的。我们来拆解《深海迷航》的声音层次。',
        cover: 'https://readdy.ai/api/search-image?query=sound%20wave%20visualization%20over%20a%20dark%20deep%20ocean%20scene%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s3-a2&orientation=landscape',
        source: '御宅屋 · 技术解析',
      },
      {
        id: 's3a3',
        title: '《山海秘境》里的东方奇幻美学',
        summary: '同样是奇幻，东方审美为什么总能拍出不一样的味道？从构图、留白到色彩说起。',
        cover: 'https://readdy.ai/api/search-image?query=oriental%20misty%20mountains%20with%20floating%20islands%20and%20ink%20painting%20style%2C%20article%20cover%20visual%2C%20deep%20midnight%20blue%20and%20warm%20orange%20grading%2C%20no%20text&width=800&height=500&seq=yz-s3-a3&orientation=landscape',
        source: '御宅屋 · 国风影像',
      },
    ],
  },
];